import { render } from "./TripsTab.vue?vue&type=template&id=3766e64c&scoped=true"
import script from "./TripsTab.vue?vue&type=script&lang=js"
export * from "./TripsTab.vue?vue&type=script&lang=js"

import "./TripsTab.vue?vue&type=style&index=0&id=3766e64c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3766e64c"]])

export default __exports__